(function(){
  var toast=document.getElementById('toast'),timer;
  function say(msg,link){
    toast.innerHTML='';toast.appendChild(document.createTextNode(msg+' '));
    if(link){var a=document.createElement('a');a.href=theme.cartUrl;a.textContent='View cart';toast.appendChild(a);}
    toast.hidden=false;clearTimeout(timer);timer=setTimeout(function(){toast.hidden=true},4000);
  }
  function refresh(){
    return fetch(theme.cartJs,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count});
    });
  }
  function add(body,btn){
    var label=btn&&btn.textContent;
    if(btn){btn.disabled=true;btn.textContent='Adding...';}
    return fetch(theme.cartAdd,{method:'POST',body:body,headers:{Accept:'application/json'}})
      .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
      .then(function(x){
        if(!x.ok){say(x.d.description||'Could not add this item.');return;}
        return refresh().then(function(){say('Added to cart.',true)});
      })
      .catch(function(){say('Something went wrong. Please try again.')})
      .then(function(){if(btn){btn.disabled=false;btn.textContent=label;}});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-variant]');
    if(!b)return;
    e.preventDefault();
    var fd=new FormData();fd.append('id',b.getAttribute('data-add-variant'));fd.append('quantity','1');
    add(fd,b);
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('form[action$="/cart/add"]'))return;
    e.preventDefault();
    add(new FormData(f),f.querySelector('[type="submit"]'));
  });
})();
